import UserProfileForm, { UserProfileValidators } from './UserProfileForm.vue'
export type { UserProfileValidators }
export default UserProfileForm
